import '../../scss/pages/join.scss';

var $ = require('jquery');
window.jQuery = $;
window.$ = $;

$( document ).ready(function() {
	$('.accordion-manual').slideUp();

	$('.btn-open-accordion-manual').on('click', function(evt) {
		if ($('.accordion-manual').hasClass('opened')) {
			$('.accordion-manual').slideUp().removeClass('opened');
			$(this).html('Show More');
		}
		else {
			$('.accordion-manual').slideDown().addClass('opened');
			$(this).html('Show Less');
		}
	});

	$('#primary-menu a').click(function(e) {
        var target_scroll_id = $(this).attr('href');
        var target_scroll_offset = $(target_scroll_id).offset();
        var scroll_distance = target_scroll_offset.top;
        var gap = 100;
        $('html, body').animate({
            scrollTop: scroll_distance - gap
        }, 500);
        e.preventDefault();
    });

    $('.container-curriculum .card').on('click', function(e) {
    	e.preventDefault();
    	e.stopPropagation();
    	var title = $('h5', this).attr("class").split(/\s+/)[1];

    	var context = $(this).parents('.carousel-inner');

    	$('.' + title + ' ~ .card-text', context).addClass('open');
    	$('.' + title + ' ~ .start-now', context).hide();
    	//$('.card-text', this).addClass('open');
    	//$('.start-now', this).hide();
    });

    $('.container-curriculum .dropdown-toggle').on('click', function(e) {
    	e.preventDefault();
    	e.stopPropagation();

    	$('.container-curriculum .dropdown-toggle').removeClass('active');
    	$('.container-curriculum .dropdown-menu').removeClass('active');
		var href = $(this).attr('href');

    	$(this).addClass('active');
    	$(href).addClass('active');
    });

    $('.row-payment-float .btn-close').on('click', function(evt) {
    	$(this).parents('.row-payment-float').remove();
    });

});

// get the sticky element
const stickyElm = document.querySelector('.position-sticky.row-payment');

const observer = new IntersectionObserver( 
  ([e]) => e.target.classList.toggle('show', e.intersectionRatio < 1),
  {threshold: [1]}
);

observer.observe(stickyElm);

